import React, { useEffect, useState } from "react";

import {
  Container,
  ContainerButtons,
  CallButton,
  ContainerHeader,
  CategoryCarrousel,
  CategoryItem,
  ProductList,
  ProductItem,
  ProductInfo,
  ProductTitle,
  ProductImage,
  ProductPrice,
  ProductDescription,
  Category,
  ContainerImage,
  Name,
} from "./styles";
import { useSelector } from "react-redux";
import tinycolor from "tinycolor2";
import { ReactComponent as PhoneIcon } from "./assets/img/phone.svg";
import { ReactComponent as WhatsappIcon } from "./assets/img/whatsapp.svg";
function MockHome(props) {
  const theme = useSelector((state) => state.general.theme);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (theme.primary && theme.secondary) {
      var color1 = tinycolor(theme.primary);
      let white = color1.getLuminance();

      const aaReadableLarge = tinycolor.isReadable(
        theme.secondary,
        theme.primary,
        { level: "AA", size: "large" },
      );
      if (aaReadableLarge) {
        setErrorMessage(null);
        if (white > 0.7) {
          setErrorMessage(
            "Tente não colocar a cor primária muito clara, pois irá dificultar a leitura",
          );
        }
      } else {
        setErrorMessage(
          "Atenção com o contraste para as cores que está utilizando",
        );
      }
      //   if (ccc.isLevelCustom(theme.primary, theme.secondary, customRatio)) {
      //     console.log("Bom");
      //   } else {
      //     console.log("Ruim");
      //   }
    }
  }, [theme.primary, theme.secondary]);
  return (
    <div className="d-flex column">
      {errorMessage && (
        <div
          style={{
            height: 44,
            width: 300,
            textAlign: "left",
            position: "relative",
          }}
        >
          <div
            style={{
              fontSize: 12,
              padding: "8px 12px",
              color: "#7f1d1d",
              background: "#fee2e2",
              border: "1px solid #fecaca",
              borderRadius: 8,
              boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span style={{ fontWeight: 700 }}>Atenção</span>
            <span style={{ color: "#991b1b" }}>{errorMessage}</span>
          </div>
        </div>
      )}
      <Container background={require("./assets/img/nexus.png")}>
        <ContainerImage>
          <img
            height="120"
            src={theme.cover}
            style={{ objectFit: "Contain", width: 280, height: 130 }}
          />
        </ContainerImage>
        <ContainerHeader>
          <Name color={theme.primary}>Nome do Restaurante</Name>
          <ContainerButtons>
            <CallButton background={theme.primary} color={theme.secondary}>
              <PhoneIcon
                fill={theme.secondary}
                style={{
                  height: 20,
                  width: 20,
                  marginRight: 10,
                }}
              />
              Ligar
            </CallButton>
            <CallButton background={theme.primary} color={theme.secondary}>
              <WhatsappIcon
                fill={theme.secondary}
                style={{ height: 20, width: 20, marginRight: 10 }}
              />{" "}
              Whatsapp
            </CallButton>
          </ContainerButtons>
          <img
            className="separator"
            src={require("./assets/img/separator.png")}
          />
          <CategoryCarrousel>
            <CategoryItem color={theme.primary}>Categoria 1</CategoryItem>
            <CategoryItem color={theme.primary}>Categoria 2</CategoryItem>
            <CategoryItem color={theme.primary}>Categoria 3</CategoryItem>
            <CategoryItem color={theme.primary}>Categoria 4</CategoryItem>
          </CategoryCarrousel>
          <Category color={theme.primary}>Categoria 1</Category>
          <ProductList>
            <ProductItem>
              <ProductInfo>
                <ProductTitle color={theme.primary}>
                  Nome do meu produto
                </ProductTitle>
                <ProductDescription>
                  Descrição do meu produto
                </ProductDescription>
                <ProductPrice color={theme.primary}>10.00 €</ProductPrice>
              </ProductInfo>
              <ProductImage src={require("./assets/img/product.jpg")} />
            </ProductItem>
          </ProductList>
        </ContainerHeader>
      </Container>
    </div>
  );
}

export default MockHome;
